import React from "react";
import { useQuery } from "react-query";
import { Kakao } from "../../components/kakao/Kakao";
import ProductService from "../../services/productService";
import { BannerResponse } from "../../types/BannerResponse";
import HomeTopBanner from "./components/Banner";
import EsimSwiper from "./components/EsimSwiper";
import EventSwiper from "./components/EventSwiper";
import FindYourNextPlan from "./components/FindYourNextPlan";
import MajorTourDest from "./components/MajorTourDest";
import MusicalSwiper from "./components/MusicalSwiper";
import RecommendAttractionPass from "./components/RecommendAttractionPass";
import RecommendGuidedTour from "./components/RecommendGuidedTour";
import RecommendTicket from "./components/RecommendTicket";
import { HomeBotBanner } from "./HomeBotBanner";
import { HomeMyInquiry } from "./HomeMyInquiry";
import { BotNav } from "../../components/layout/BotNav";

const HomePage: React.FC = () => {
  const { data: bannerData } = useQuery<BannerResponse>(
    ["banner"],
    async () => {
      const result = await ProductService.getBanner();
      if (!result) {
        throw new Error("Failed to fetch home page data");
      }
      return result;
    },
  );
  return (
    <>
      <div>
        <FindYourNextPlan banners={bannerData?.mainBanner || []} />
        {/* This main content with padding */}
        <div className="ui-container">
          <HomeTopBanner
            banners={bannerData?.topBanner || []}
            bannerPopup={bannerData?.popupBanner || []}
          />
          <MajorTourDest className="pt-10 sm:pt-[4.5rem]" />
        </div>
        <div className="bg-[#F7F8FA]">
          <div className="ui-container">
            <RecommendAttractionPass className="mt-10 py-10 sm:mt-20 sm:py-20" />
          </div>
        </div>
        <div className="ui-container">
          <RecommendTicket className="pt-10 sm:pt-[4.5rem]" />
          <RecommendGuidedTour className="pt-10 sm:pt-[4.5rem]" />
          <div className="pt-10 sm:pt-[4.5rem]" />
          <HomeBotBanner />
          <div className="mx-auto overflow-hidden pt-10 sm:pt-[4.5rem]">
            <MusicalSwiper />
          </div>
          <div className="mx-auto max-w-[84.125rem] overflow-hidden pt-10 sm:pt-[4.5rem]">
            <EventSwiper />
          </div>
          <div className="mx-auto pt-10 sm:pt-[4.5rem]">
            <EsimSwiper />
          </div>
          <HomeMyInquiry />
        </div>
      </div>
      <BotNav active="HOME" />
    </>
  );
};

export default HomePage;
